var _rect, _rect2, _rect3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.47217,
    width: 17.5,
    height: 17.5,
    rx: 3.75,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.47217,
    width: 17.5,
    height: 17.5,
    rx: 3.75,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.47217,
    width: 17.5,
    height: 17.5,
    rx: 3.75,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 6.78467C14.375 7.30243 13.9553 7.72217 13.4375 7.72217C12.9197 7.72217 12.5 7.30243 12.5 6.78467C12.5 6.2669 12.9197 5.84717 13.4375 5.84717C13.9553 5.84717 14.375 6.2669 14.375 6.78467Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.3472C11.7259 13.3472 13.125 11.9481 13.125 10.2222C13.125 8.49628 11.7259 7.09717 10 7.09717C8.27411 7.09717 6.875 8.49628 6.875 10.2222C6.875 11.9481 8.27411 13.3472 10 13.3472ZM10 12.0972C11.0355 12.0972 11.875 11.2577 11.875 10.2222C11.875 9.18663 11.0355 8.34717 10 8.34717C8.96447 8.34717 8.125 9.18663 8.125 10.2222C8.125 11.2577 8.96447 12.0972 10 12.0972Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 9.97217C3.75 7.87197 3.75 6.82187 4.15873 6.0197C4.51825 5.3141 5.09193 4.74042 5.79754 4.38089C6.5997 3.97217 7.6498 3.97217 9.75 3.97217H10.25C12.3502 3.97217 13.4003 3.97217 14.2025 4.38089C14.9081 4.74042 15.4817 5.3141 15.8413 6.0197C16.25 6.82187 16.25 7.87197 16.25 9.97217V10.4722C16.25 12.5724 16.25 13.6225 15.8413 14.4246C15.4817 15.1302 14.9081 15.7039 14.2025 16.0634C13.4003 16.4722 12.3502 16.4722 10.25 16.4722H9.75C7.6498 16.4722 6.5997 16.4722 5.79754 16.0634C5.09193 15.7039 4.51825 15.1302 4.15873 14.4246C3.75 13.6225 3.75 12.5724 3.75 10.4722V9.97217ZM9.75 5.22217H10.25C11.3207 5.22217 12.0486 5.22314 12.6112 5.26911C13.1592 5.31388 13.4395 5.39504 13.635 5.49465C14.1054 5.73434 14.4878 6.11679 14.7275 6.58719C14.8271 6.78269 14.9083 7.06295 14.9531 7.61097C14.999 8.17358 15 8.90144 15 9.97217V10.4722C15 11.5429 14.999 12.2708 14.9531 12.8334C14.9083 13.3814 14.8271 13.6616 14.7275 13.8571C14.4878 14.3275 14.1054 14.71 13.635 14.9497C13.4395 15.0493 13.1592 15.1305 12.6112 15.1752C12.0486 15.2212 11.3207 15.2222 10.25 15.2222H9.75C8.67928 15.2222 7.95141 15.2212 7.3888 15.1752C6.84078 15.1305 6.56052 15.0493 6.36502 14.9497C5.89462 14.71 5.51217 14.3275 5.27248 13.8571C5.17287 13.6616 5.09171 13.3814 5.04694 12.8334C5.00097 12.2708 5 11.5429 5 10.4722V9.97217C5 8.90144 5.00097 8.17358 5.04694 7.61097C5.09171 7.06295 5.17287 6.78269 5.27248 6.58719C5.51217 6.11679 5.89462 5.73434 6.36502 5.49465C6.56052 5.39504 6.84078 5.31388 7.3888 5.26911C7.95141 5.22314 8.67928 5.22217 9.75 5.22217Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3462906abf60ede8ebda6f3fc1a9f6ec.svg";
export { ForwardRef as ReactComponent };